/**
 * Centralized error message constants used by error classes and validation utilities.
 */
export const ERRORS = {
    GENERAL: {
        FALLBACK_MESSAGE: "Please try again at a later time.",
        BACKEND_DETAILS: (errors) => `Details: ${errors.join(", ")}`
    },
    TIMEOUT: {
        WITH_DURATION: (seconds) => `Request timed out after ${seconds}s. The server may be experiencing heavy load. Please try again.`,
        GENERIC: "Request timed out. The server may be experiencing heavy load. Please try again."
    },
    NETWORK: {
        DNS_FAILED: "Cannot reach server (DNS lookup failed). Please check your internet connection.",
        CONNECTION_REFUSED: "Cannot connect to server (connection refused). The service may be temporarily unavailable.",
        GENERIC: "Network error. Please check your internet connection and try again."
    },
    AUTH: {
        SESSION_EXPIRED: "Session expired. Please log in again.",
        ACCESS_DENIED: "Access denied. You don't have permission to perform this action."
    },
    SERVER: {
        BAD_GATEWAY: "Bad gateway. The server received an invalid response. Please try again.",
        SERVICE_UNAVAILABLE: "Service temporarily unavailable. Please try again in a few minutes."
    },
    HTTP: {
        BAD_REQUEST: "Invalid request. Please check your input and try again.",
        NOT_FOUND: "Resource not found. The requested item may have been deleted.",
        CONFLICT: "Conflict. The resource may have been modified by another user.",
        RATE_LIMIT: "Too many requests. Please wait a moment and try again.",
        SERVER_ERROR: (status) => `Server error (${status}). Please try again or contact support if this persists.`
    }
};
//# sourceMappingURL=errorMessages.js.map